/**
 * The teiasoft grids emit custom icon / context menu clicks as a single string: `action|{row as JSON}`.
 * Row values may themselves contain "|" (e.g. a customer enquiry no like "E01 | Toyo | AG"), so the
 * payload must be taken from the first separator onwards, never via `split("|")[1]`.
 */
export interface GridActionEvent<T = any> {
  action: string;
  /** Parsed row, undefined when the event carries no payload (e.g. "clearDataItems"). */
  row: T | undefined;
}

export function parseGridActionEvent<T = any>(evt: string | null | undefined): GridActionEvent<T> {
  const raw = evt == null ? '' : String(evt);
  const separatorIndex = raw.indexOf('|');
  if (separatorIndex === -1) {
    return { action: raw, row: undefined };
  }

  const payload = raw.slice(separatorIndex + 1);
  return {
    action: raw.slice(0, separatorIndex),
    row: payload.trim() === '' ? undefined : JSON.parse(payload) as T
  };
}
